<script setup lang="ts">
import { onMounted } from 'vue'

import {
  triggerViewItemEvent,
  triggerViewProductDetailEvent,
} from '@shared/event/events/product'
import { waitForGtmLoaded } from '@shared/fondof-fn/dom/gtm'
import type { BreadcrumbItem } from '@shared/shop-api/category/types'
import type { ProductWithVariants } from '@shared/shop-api/product/types'

const { product, breadcrumb } = defineProps<{
  product: ProductWithVariants
  breadcrumb: BreadcrumbItem[] | undefined
}>()

onMounted(() => {
  if (product) {
    waitForGtmLoaded(() => {
      const [variant] = product.variants

      triggerViewItemEvent({
        sku: variant.sku,
        brand: product.attributes.brand,
        price: variant.price,
        modelUntranslated: String(product.attributes.modelUntranslated),
        styleUntranslated: String(product.attributes.styleUntranslated),
        size: variant.size || '',
      })

      if (breadcrumb) {
        triggerViewProductDetailEvent({ product, breadcrumb })
      }
    })
  }
})
</script>
<template>
  <slot />
</template>
